// Hideo - calendar dates in local time, shared by the Calendar, the Timeline, the agenda and the published videos
import { fmtDate } from '../i18n'

/** yyyy-mm-dd of a day, in local time */
export const isoDay = (d: Date): string => d.toLocaleDateString('sv-SE')
/** The day of a yyyy-mm-dd, at local midnight */
export const dayOf = (iso: string): Date => new Date(iso + 'T00:00')
/** Monday of the week of a day (at midnight) */
export function mondayOf(d: Date): Date {
  const x = new Date(d.getFullYear(), d.getMonth(), d.getDate())
  x.setDate(x.getDate() - (x.getDay() + 6) % 7)
  return x
}
/** First day of the month of a day */
export const firstOfMonth = (d: Date): Date => new Date(d.getFullYear(), d.getMonth(), 1)
/** The same day n months later, as the 1st of that month (n < 0: before) */
export const addMonths = (d: Date, n: number): Date => new Date(d.getFullYear(), d.getMonth() + n, 1)
/** The day n days later (n < 0: before), at midnight */
export const addDays = (d: Date, n: number): Date => new Date(d.getFullYear(), d.getMonth(), d.getDate() + n)
/** Switching from a month to a week: this week if the month is the current one, otherwise the first week of the month */
export function weekOfMonth(month: Date, now: Date): Date {
  const same = now.getFullYear() === month.getFullYear() && now.getMonth() === month.getMonth()
  return mondayOf(same ? now : month)
}
/** Title of a span of days: "12–18 ott 2026", or "28 set – 4 ott 2026" across two months */
export function spanTitle(first: Date, last: Date): string {
  return first.getMonth() === last.getMonth()
    ? `${first.getDate()}–${last.getDate()} ${fmtDate(last, { month: 'short', year: 'numeric' })}`
    : `${fmtDate(first, { day: 'numeric', month: 'short' })} – ${fmtDate(last, { day: 'numeric', month: 'short', year: 'numeric' })}`
}
/** A work moment as stored (workStart, doneAt, publishedAt): "YYYY-MM-DDTHH:MM" in local time */
export const WORK_TIME_RE = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/
